import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import api from "@/lib/api";

export default function ActivityLogPage() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/activity-log", { params: { limit: 300 } }).then(({ data }) => setLogs(data)); }, []);
  return (
    <AdminLayout title="Activity Log" showTurnBoard={false}>
      <div className="bg-white rounded-2xl border border-zen-border overflow-hidden">
        <table className="w-full">
          <thead className="bg-zen-surface text-xs uppercase text-zen-muted"><tr>
            <th className="text-left px-5 py-3">Time</th><th className="text-left px-5 py-3">User</th><th className="text-left px-5 py-3">Action</th><th className="text-left px-5 py-3">Details</th>
          </tr></thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-zen-border" data-testid={`log-row-${l.id}`}>
                <td className="px-5 py-3 text-xs text-zen-muted">{new Date(l.timestamp).toLocaleString("en-US")}</td>
                <td className="px-5 py-3 text-sm font-medium">{l.user}</td>
                <td className="px-5 py-3 text-sm">{l.action}</td>
                <td className="px-5 py-3 text-xs text-zen-muted">{l.details}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan="4" className="text-center py-12 text-zen-muted">No activity</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
